import PlaylistTeaser from '@widgets/Teaser/playlist'
import { CleanedUpPlaylistTeaserAPIProps } from '@widgets/Video/playlist/types'
import { FunctionComponent, RefObject, useCallback, useRef } from 'react'
import styled, { css } from 'styled-components'
import PlaylistItemWrapper from './PlaylistItemWrapper'
import { desktopCSS } from 'measures/responsive'

interface PlaylistWrapperProps {
  children: CleanedUpPlaylistTeaserAPIProps[]
}

const StyledPlaylistWrapper = styled.div`
  position: relative;
  padding: 18px 18px 0 18px;
  overflow: scroll;

  ${desktopCSS(css`
    -ms-overflow-style: none; /* IE and Edge */
    scrollbar-width: none; /* Firefox */
    &::-webkit-scrollbar {
      display: none;
    }
  `)}
`

const scrollToElementOffset = (
  offset: number,
  ref: RefObject<HTMLDivElement>
): void => {
  if (ref.current) {
    ref.current.scrollTop = offset
  }
}

const PlaylistWrapper: FunctionComponent<PlaylistWrapperProps> = ({
  children,
}) => {
  const playlistWrapperRef = useRef<HTMLDivElement>(null)
  const scrollToElement = useCallback<(offset: number) => void>(
    (offset) => {
      scrollToElementOffset(offset, playlistWrapperRef)
    },
    [playlistWrapperRef]
  )
  return (
    <StyledPlaylistWrapper ref={playlistWrapperRef}>
      {children.map((item) => {
        const { articleId, image, video, title, catchword, link, isActive } =
          item

        return (
          <PlaylistItemWrapper
            key={articleId}
            isActive={isActive}
            scrollToElement={scrollToElement}>
            <PlaylistTeaser
              {...{
                articleId,
                image,
                video,
                title,
                catchword,
                link,
                isActive,
              }}
            />
          </PlaylistItemWrapper>
        )
      })}
    </StyledPlaylistWrapper>
  )
}

export default PlaylistWrapper
